import nanoid from "../nanoid";

const mapIdAndValue = (array: string[]) => array.map((question) => ({ id: nanoid(), value: question }));

export default mapIdAndValue;
